export const GET_VOLUNTEERREQUESTS = "GET_VOLUNTEERREQUESTS";
export const FILTER_VOLUNTEERREQUESTS = "FILTER_VOLUNTEERREQUESTS";
export const ADD_VOLUNTEERREQUEST = "ADD_VOLUNTEERREQUEST";
export const EDIT_VOLUNTEERREQUEST = "EDIT_VOLUNTEERREQUEST";
export const GET_VOLUNTEERREQUEST = "GET_VOLUNTEERREQUEST";
export const RESET_VOLUNTEERREQUEST = "RESET_VOLUNTEERREQUEST";
export const VOLUNTEERREQUESTS_ERROR = "VOLUNTEERREQUESTS_ERROR";
